module.exports = __webpack_public_path__ + "img/credisan.97bf4f25.svg";